<template>
  <div v-if="Lib.checkPower('beauty-2-ckdd',2)" id="searchBar" class="overflowTop">
    <drawer title="订单筛选" :display.sync="display">
      <div class="li">
        <p>快速查找</p>
        <el-input v-model="searchVal" size="small" class="width_300" placeholder="请输入订单号/顾客姓名/手机尾号" :clearable="true" @keyup.enter.native="allSearch">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="allSearch"></i>
        </el-input>
      </div>
      <div class="li">
        <p>{{ orderTypeVal == 5 ? '使用' : '开单' }}日期</p>
        <el-date-picker v-model="dateVal" size="small" class="width_300" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :editable="false" @change="chooseDate">
        </el-date-picker>
      </div>
      <div class="li">
        <p>{{ orderTypeVal == 5 ? '离店' : '结算' }}日期</p>
        <el-date-picker v-model="settlementDateVal" size="small" class="width_300" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :editable="false" @change="chooseSettlementDate">
        </el-date-picker>
      </div>
      <div class="li">
        <p>顾客类型</p>
        <el-button size="small" :type="customerTypeVal == '' ? 'primary' : ''" @click="chooseCustomerType('')">全部</el-button>
        <el-button size="small" :type="customerTypeVal == '0' ? 'primary' : ''" @click="chooseCustomerType('0')">新增顾客</el-button>
        <el-button size="small" :type="customerTypeVal == '1' ? 'primary' : ''" @click="chooseCustomerType('1')">会员顾客</el-button>
      </div>
      <div class="li">
        <p>订单状态</p>
        <el-button size="small" :type="orderStatusVal == '0' ? 'primary' : ''" @click="chooseOrderStatus('0')">全部</el-button>
        <el-button size="small" :type="orderStatusVal == '1' ? 'primary' : ''" @click="chooseOrderStatus('1')">待结算</el-button>
        <el-button size="small" :type="orderStatusVal == '3' ? 'primary' : ''" @click="chooseOrderStatus('3')">部分支付</el-button>
        <el-button size="small" :type="orderStatusVal == '2' ? 'primary' : ''" @click="chooseOrderStatus('2')">已结算</el-button>
        <el-button size="small" :type="orderStatusVal == '4' ? 'primary' : ''" @click="chooseOrderStatus('4')">已退款</el-button>
      </div>
      <div class="li">
        <p>订单类型</p>
        <el-button size="small" :type="orderTypeVal == '' ? 'primary' : ''" @click="chooseOrderTypeVal('')">全部</el-button>
        <el-button size="small" :type="orderTypeVal == 1 ? 'primary' : ''" @click="chooseOrderTypeVal('1')">服务订单</el-button>
        <el-button size="small" :type="orderTypeVal == 2 ? 'primary' : ''" @click="chooseOrderTypeVal('2')">快捷收银订单</el-button>
        <el-button size="small" :type="orderTypeVal == 4 ? 'primary' : ''" @click="chooseOrderTypeVal('4')">直接划扣订单</el-button>
        <el-button size="small" :type="orderTypeVal == 3 ? 'primary' : ''" @click="chooseOrderTypeVal('3')">购买套餐订单</el-button>
        <el-button size="small" :type="orderTypeVal == 5 ? 'primary' : ''" @click="chooseOrderTypeVal('5')">房间订单</el-button>
        <el-button size="small" :type="orderTypeVal == 6 ? 'primary' : ''" @click="chooseOrderTypeVal('6')">预约订单</el-button>
        <!-- <el-button size="small" :type="orderTypeVal == 7 ? 'primary' : ''" @click="chooseOrderTypeVal('7')">服务订单&预约订单</el-button> -->
        <!-- <el-button size="small" :type="orderTypeVal == 7 ? 'primary' : ''" @click="chooseOrderTypeVal('8')">服务订单&房间订单</el-button> -->
        <!-- <el-button size="small" :type="orderTypeVal == 7 ? 'primary' : ''" @click="chooseOrderTypeVal('9')">服务订单&预约订单&房间订单</el-button> -->
      </div>
      <div class="li">
        <p>备注搜索</p>
        <el-input v-model="remarkVal" size="small" class="width_300" placeholder="请输入备注" :maxlength="100" :clearable="true" @keyup.enter.native="allSearch">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="allSearch"></i>
        </el-input>
      </div>
      <div class="li">
        <p style="height: 28px;line-height: 28px;">
          {{ orderTypeVal == 5 ? '操作' : '服务' }}人员
        </p>
        <el-select v-model="serviceStaffVal" style="width: 100%;" size="small" multiple placeholder="请选择员工" @change="allSearch">
          <el-option v-for="(v,n) in staffList" :key="n" :label="v.technicianName" :value="v.technicianId"></el-option>
        </el-select>
      </div>
      <div class="li">
        <p>开单人员</p>
        <el-select v-model="openStaffVal" style="width: 100%;" size="small" multiple placeholder="请选择员工" @change="allSearch">
          <el-option v-for="(v,n) in staffList" :key="n" :label="v.technicianName" :value="v.technicianId"></el-option>
        </el-select>
      </div>
      <div class="li">
        <p>结算人员</p>
        <el-select v-model="settlementStaffVal" style="width: 100%;" size="small" multiple placeholder="请选择员工" @change="allSearch">
          <el-option v-for="(v,n) in staffList" :key="n" :label="v.technicianName" :value="v.technicianId"></el-option>
        </el-select>
      </div>
      <div class="li">
        <p>订单来源</p>
        <el-button size="small" :type="orderSourceVal == null ? 'primary' : ''" @click="orderSource(null)">全部</el-button>
        <el-button size="small" :type="orderSourceVal == 0 ? 'primary' : ''" @click="orderSource(0)">电脑端</el-button>
        <el-button size="small" :type="orderSourceVal == 2 ? 'primary' : ''" @click="orderSource(2)">店员APP</el-button>
        <el-button size="small" :type="orderSourceVal == 1 ? 'primary' : ''" @click="orderSource(1)">粉丝端</el-button>
      </div>
      <div class="li">
        <p>使用权益</p>
        <el-button size="small" :type="useQyVal == '' ? 'primary' : ''" @click="useQy('')">全部</el-button>
        <el-button size="small" :type="useQyVal == '5' ? 'primary' : ''" @click="useQy('5')">改价</el-button>
        <el-button size="small" :type="useQyVal == '4' ? 'primary' : ''" @click="useQy('4')">会员权益</el-button>
        <el-button size="small" :type="useQyVal == '1' ? 'primary' : ''" @click="useQy('1')">经销商权益</el-button>
        <el-button size="small" :type="useQyVal == '3' ? 'primary' : ''" @click="useQy('3')">定时打折</el-button>
        <el-button size="small" :type="useQyVal == '2' ? 'primary' : ''" @click="useQy('2')">特价促销</el-button>
        <el-button size="small" :type="useQyVal == '6' ? 'primary' : ''" @click="useQy('6')">套餐划扣</el-button>
        <el-button size="small" :type="useQyVal == '7' ? 'primary' : ''" @click="useQy('7')">电子票划扣</el-button>
        <el-button size="small" :type="useQyVal == '8' ? 'primary' : ''" @click="useQy('8')">赠品划扣</el-button>
        <el-button size="small" :type="useQyVal == '-1' ? 'primary' : ''" @click="useQy('-1')">不使用</el-button>
      </div>
      <div class="li">
        <p>使用优惠</p>
        <el-button size="small" :type="useDiscountVal == '' ? 'primary' : ''" @click="useDiscount('')">全部</el-button>
        <el-button size="small" :type="useDiscountVal == '1' ? 'primary' : ''" @click="useDiscount('1')">会员优惠</el-button>
        <el-button size="small" :type="useDiscountVal == '2' ? 'primary' : ''" @click="useDiscount('2')">改价优惠</el-button>
        <el-button size="small" :type="useDiscountVal == '3' ? 'primary' : ''" @click="useDiscount('3')">整单改价优惠</el-button>
        <el-button size="small" :type="useDiscountVal == '4' ? 'primary' : ''" @click="useDiscount('4')">优惠券抵扣</el-button>
        <el-button size="small" :type="useDiscountVal == '5' ? 'primary' : ''" @click="useDiscount('5')">积分自定义抵扣</el-button>
        <el-button size="small" :type="useDiscountVal == '7' ? 'primary' : ''" @click="useDiscount('7')">赠送活动</el-button>
        <el-button size="small" :type="useDiscountVal == '8' ? 'primary' : ''" @click="useDiscount('8')">定时打折</el-button>
        <el-button size="small" :type="useDiscountVal == '9' ? 'primary' : ''" @click="useDiscount('9')">特价促销</el-button>
        <el-button size="small" :type="useDiscountVal == '10' ? 'primary' : ''" @click="useDiscount('10')">买赠活动</el-button>
        <el-button size="small" :type="useDiscountVal == '11' ? 'primary' : ''" @click="useDiscount('11')">满赠活动</el-button>
        <el-button size="small" :type="useDiscountVal == '-1' ? 'primary' : ''" @click="useDiscount('-1')">不使用</el-button>
      </div>
      <div class="li">
        <p>使用划扣</p>
        <el-button size="small" :type="buckleVal == null ? 'primary' : ''" @click="buckle(null)">全部</el-button>
        <el-button size="small" :type="buckleVal == 1 ? 'primary' : ''" @click="buckle(1)">套餐划扣</el-button>
        <el-button size="small" :type="buckleVal == 2 ? 'primary' : ''" @click="buckle(2)">电子票划扣</el-button>
        <el-button size="small" :type="buckleVal == 3 ? 'primary' : ''" @click="buckle(3)">赠品划扣</el-button>
      </div>
      <div v-if="menusList.find(data => data.iDenTi === 'beauty-1-ft')" class="li">
        <p>房间搜索</p>
        <el-select v-model="roomVal" style="width: 100%;" size="small" multiple placeholder="请选择房间" @change="allSearch">
          <el-option v-for="(v,n) in roomList" :key="n" :label="v.roomName" :value="v.id"></el-option>
        </el-select>
      </div>
      <div v-if="menusList.find(data => data.iDenTi === 'beauty-1-sp')" class="li">
        <p>手牌搜索</p>
        <el-input v-model="handCardVal" size="small" class="width_300" placeholder="请输入手牌号码" :maxlength="6" :clearable="true" @keyup.enter.native="allSearch">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="allSearch"></i>
        </el-input>
      </div>
      <div class="dfoot" @click="resetScreen">重置</div>
    </drawer>
    <i class="iconfont backTop" @click="Lib.backTop()">&#xe62f;</i>
    <div class="orderTab">
      <el-tabs ref="tabs" v-model="activeName" :before-leave="beforeLeave">
        <el-tab-pane :label="'全部('+allCount+')'" name="service-all">
        </el-tab-pane>
        <el-tab-pane :label="'待结算('+noPayCount+')'" name="service-not">
        </el-tab-pane>
        <el-tab-pane :label="'部分支付('+partPayCount+')'" name="service-part">
        </el-tab-pane>
        <el-tab-pane :label="'已结算('+payCount+')'" name="service-end">
        </el-tab-pane>
        <el-tab-pane :label="'已退款('+refundCount+')'" name="service-refund">
        </el-tab-pane>
      </el-tabs>
      <i class="iconfont screen" :style="screenStatus == 1 ? 'color: #f56c6c' : ''" @click="display = true">&#xe63f;</i>
      <i class="iconfont export" @click="orderExport">&#xe8aa;</i>
      <!-- <label v-if="serviceStaffVal.length > 0" class="screenNum">{{ serviceStaffVal.length }}</label> -->
    </div>
    <service-all :new-search-val="newSearchVal" :date-val="dateVal" :customer-type-val="customerTypeVal" :service-staff-val="serviceStaffVal" :open-staff-val="openStaffVal" :settlement-staff-val="settlementStaffVal" :order-status-val="orderStatusVal" :order-source-val="orderSourceVal" :buckle-val="buckleVal" :use-qy-val="useQyVal" :use-discount-val="useDiscountVal" :room-val="roomVal" :hand-card-val="newHandCardVal" :order-type-val="orderTypeVal" :settlement-date-val="settlementDateVal" :new-remark-val="newRemarkVal" :reset-screen-status="resetScreenStatus" @getDelStatus="getStatus" @getOrderCount="getCount" @loadStatus="getLoadStatus"></service-all>

    <!--预约取消 /拒绝弹窗-->
    <el-dialog class="exportOrderDia" title="导出订单" :visible.sync="exportDia" width="800px" :append-to-body="true">
      <h5>
        导出订单的数据范围，将根据订单列表所筛选的订单数据生成报表<br />
        导出订单的时间范围，最多不超过3个月，将以下单时间为计算基准，导出最近3个月的订单
      </h5>
      <div class="exportChoose">
        <p>导出表头选择</p>
        <div class="ecCheckbox">
          <div v-for="(item,index) in exportList" :key="index" class="eccDiv">
            <h6>{{ item.groupName }}</h6>
            <el-checkbox-group v-model="item.choose">
              <el-checkbox v-for="(v,n) in item.list" :key="n" :label="v.id" :disabled="v.entryName == '订单号' ? true : false" @change="checkVal(v)">{{ v.entryName }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="filterReset">重 置</el-button>
        <el-button type="primary" @click="exportOrder">导 出</el-button>
      </span>
    </el-dialog>
  </div>
  <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
</template>

<script>
import drawer from '../publicVue/drawer';
import ServiceAll from './template/all/index';
import {
  getVacationListByStatus, getAllOrderCountBean, getSearchRoomList, getOrderEntryListByMainId, saveOrUpdateEntry, updateDefaultEntry
} from './api';

export default {
  components: {
    ServiceAll,
    drawer
  },
  data() {
    return {
      display: false,

      activeName: 'service-not', // tab切换
      searchVal: '', // 快速搜索
      newSearchVal: '',
      remarkVal: '', // 备注搜索
      newRemarkVal: '',
      dateVal: [], // 开单日期
      pickerOptions: { // 只能查询请今天之前的时间
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      customerTypeVal: '', // 顾客类型
      serviceStaffVal: [], // 服务员工
      staffList: [], // 服务员工列表
      orderStatusVal: '1', // 订单状态
      orderTypeVal: '', // 订单类型
      settlementDateVal: [], // 结算日期
      deleteStatus: false, // 订单删除状态

      allCount: 0, // 全部订单数量
      noPayCount: 0, // 待结算订单数量
      partPayCount: 0, // 部分支付订单数量
      payCount: 0, // 已结算订单数量
      refundCount: 0, // 已退款订单数量

      screenStatus: 2, // 筛选状态  1有筛选  2初始
      resetScreenStatus: 1, // 重置状态  1重置完成  2开始重置

      // 6.2
      loadStatus: false,

      // 6.6
      orderSourceVal: null, // 选择订单来源
      useQyVal: '', // 选择权益状态
      useDiscountVal: '', // 选择优惠状态
      roomList: [], // 房间列表
      roomVal: [], // 搜索的房间值
      handCardVal: '',
      newHandCardVal: '',
      buckleVal: null,
      openStaffVal: [], // 开单人员
      settlementStaffVal: [], // 结算人员
      menusList: [],

      exportDia: false, // 导出订单弹窗
      exportList: []
    };
  },
  watch: {
    activeName(val) {
      if (this.resetScreenStatus == 2) return;
      this.Lib.backTop();
      if (val == 'service-all') {
        this.orderStatusVal = '0';
      } else if (val == 'service-not') {
        this.orderStatusVal = '1';
      } else if (val == 'service-end') {
        this.orderStatusVal = '2';
      } else if (val == 'service-part') {
        this.orderStatusVal = '3';
      } else if (val == 'service-refund') {
        this.orderStatusVal = '4';
      }
      this.getListCount();
    },
    deleteStatus(val) {
      if (this.resetScreenStatus == 2) return;
      if (val == true) {
        this.getListCount();
        this.deleteStatus = false;
      }
    }
  },
  activated() {
    this.chooseOrderStatus(window.sessionStorage.orderListStatus || '1');
    this.getServiceStaffList();
    this.getRoomList();
    this.getListCount();
    this.menusList = JSON.parse(sessionStorage.getItem('menusList'));
  },
  deactivated() {
    this.resetScreen();
    window.sessionStorage.orderListStatus = '1';
    this.orderStatusVal = '1';
    this.activeName = 'service-not';
  },
  methods: {
    // 订单导出弹窗
    orderExport() {
      getOrderEntryListByMainId({ mainId: window.sessionStorage.mainId }).then((res) => {
        if (res.code == 0) {
          this.exportDia = true;
          res.data.forEach((a) => {
            a.choose = [];
            a.list.forEach((b) => {
              if (b.status == 1) {
                a.choose.push(b.id);
              }
            });
          });
          this.exportList = res.data;
        } else {
          // console.log(res)
        }
      });
    },
    // 筛选重置
    filterReset() {
      updateDefaultEntry().then((res) => {
        if (res.code == 0) {
          this.orderExport();
        } else {
          // console.log(res)
        }
      });
    },
    // 导出订单
    exportOrder() {
      let technicianIds = '';
      let openTechnicianIds = '';
      let closeTechnicianIds = '';
      this.serviceStaffVal.forEach((a) => {
        technicianIds += `${a},`;
      });
      this.openStaffVal.forEach((a) => {
        openTechnicianIds += `${a},`;
      });
      this.settlementStaffVal.forEach((a) => {
        closeTechnicianIds += `${a},`;
      });
      let roomIds = '';
      this.roomVal.forEach((a) => {
        roomIds += `${a},`;
      });
      const data = {
        busId: sessionStorage.getItem('busId'),
        mainId: window.sessionStorage.mainId,
        keyWord: this.newSearchVal,
        remark: this.newRemarkVal,
        openStartDate: this.dateVal ? this.dateVal.length > 0 ? this.dateVal[0] : '' : '',
        openEndDate: this.dateVal ? this.dateVal.length > 0 ? this.dateVal[1] : '' : '',
        closeStartDate: this.settlementDateVal ? this.settlementDateVal.length > 0 ? this.settlementDateVal[0] : '' : '',
        closeEndDate: this.settlementDateVal ? this.settlementDateVal.length > 0 ? this.settlementDateVal[1] : '' : '',
        orderStatus: window.sessionStorage.orderListStatus || this.orderStatusVal || '',
        orderType: this.orderTypeVal || '',
        memberType: this.customerTypeVal || '',
        technicianIds,
        openTechnicianIds,
        closeTechnicianIds,
        buySource: this.orderSourceVal, // 来源
        rightsType: this.useQyVal, // 使用权益
        discountsType: this.useDiscountVal, // 使用优惠
        deductType: this.buckleVal, // 划扣类型
        handSearch: this.handCardVal, // 手牌查询
        roomIds, // 房间ID
      };
      this.$root.$children[0].fatherExport('exportAllOrderList', `${this.Lib.A()}/erp/customerOrder/exportAllOrderList`, data);
    },
    // 勾选导出订单的类型
    checkVal(obj) {
      if (obj.status == 1) {
        obj.status = 0;
      } else {
        obj.status = 1;
      }
      const arr = [obj];
      saveOrUpdateEntry(arr).then((res) => {
        console.log(res);
      });
    },
    // 获取文本编辑器的内容
    getStatus(val) {
      this.deleteStatus = val;
    },
    // 获取子组件状态
    getCount() {
      this.getListCount();
    },
    // 获取子组件加载状态
    getLoadStatus(val) {
      this.loadStatus = val;
    },
    beforeLeave() {
      return !this.loadStatus;
    },
    // 获取订单列表数据
    getListCount() {
      if (this.newSearchVal != '' || (this.dateVal ? this.dateVal.length != 0 : false) || this.customerTypeVal != '' || this.orderTypeVal != '' || this.serviceStaffVal.length > 0 || this.openStaffVal.length > 0 || this.settlementStaffVal.length > 0 || (this.settlementDateVal ? this.settlementDateVal.length != 0 : false)) {
        this.screenStatus = 1;
      } else {
        this.screenStatus = 2;
      }
      let technicianIds = '';
      let openTechnicianIds = '';
      let closeTechnicianIds = '';
      this.serviceStaffVal.forEach((a) => {
        technicianIds += `${a},`;
      });
      this.openStaffVal.forEach((a) => {
        openTechnicianIds += `${a},`;
      });
      this.settlementStaffVal.forEach((a) => {
        closeTechnicianIds += `${a},`;
      });
      let roomIds = '';
      this.roomVal.forEach((a) => {
        roomIds += `${a},`;
      });
      const data = {
        mainId: window.sessionStorage.mainId,
        keyWord: this.newSearchVal,
        remark: this.newRemarkVal,
        openStartDate: this.dateVal ? this.dateVal.length > 0 ? this.dateVal[0] : '' : '',
        openEndDate: this.dateVal ? this.dateVal.length > 0 ? this.dateVal[1] : '' : '',
        closeStartDate: this.settlementDateVal ? this.settlementDateVal.length > 0 ? this.settlementDateVal[0] : '' : '',
        closeEndDate: this.settlementDateVal ? this.settlementDateVal.length > 0 ? this.settlementDateVal[1] : '' : '',
        orderStatus: window.sessionStorage.orderListStatus || this.orderStatusVal || '',
        orderType: this.orderTypeVal || '',
        memberType: this.customerTypeVal || '',
        technicianIds,
        openTechnicianIds,
        closeTechnicianIds,
        buySource: this.orderSourceVal, // 来源
        rightsType: this.useQyVal, // 使用权益
        discountsType: this.useDiscountVal, // 使用优惠
        deductType: this.buckleVal, // 划扣类型
        handSearch: this.handCardVal, // 手牌查询
        roomIds, // 房间ID
      };
      getAllOrderCountBean(data).then((res) => {
        this.allCount = res.data.count4All;
        this.noPayCount = res.data.count4NoPay;
        this.payCount = res.data.count4Pay;
        this.partPayCount = res.data.count4PartPay;
        this.refundCount = res.data.count4RefundPay;
        this.Lib.resetTabActivePosition(this.$refs.tabs.$el);
      });
    },
    allSearch() {
      this.newRemarkVal = this.remarkVal;
      this.newHandCardVal = this.handCardVal;
      this.newSearchVal = this.searchVal;
      this.getListCount();
    },
    // 选择开单日期
    chooseDate(val) {
      if (this.resetScreenStatus == 2) return;
      if (!val) this.dateVal = [];
      this.getListCount();
    },
    // 选择顾客类型
    chooseCustomerType(val) {
      this.customerTypeVal = val;
      this.getListCount();
    },
    // 重置筛选内容
    resetScreen() {
      this.resetScreenStatus = 2;
      this.orderStatusVal = '99'; // 修改jira--1408问题，触发change事件
      this.activeName = 'service-not';
      this.searchVal = '';
      this.newSearchVal = '';
      this.remarkVal = '';
      this.newRemarkVal = '';
      this.dateVal = [];
      this.customerTypeVal = '';
      this.serviceStaffVal = [];
      this.openStaffVal = [];
      this.settlementStaffVal = [];
      this.handCardVal = '';
      this.newHandCardVal = '';
      this.roomVal = [];
      this.useDiscountVal = '';
      this.useQyVal = '';
      this.orderSourceVal = null;
      this.buckleVal = null;
      this.staffList.forEach((a) => {
        a.status = 2;
      });
      this.orderTypeVal = '';
      this.settlementDateVal = [];
      this.$forceUpdate();
      this.getListCount();
      setTimeout(() => {
        this.resetScreenStatus = 1;
        this.orderStatusVal = '1';
      }, 50);
    },
    // 获取项目员工列表
    getServiceStaffList() {
      getVacationListByStatus({ status: '' }).then((res) => {
        if (res.code == 0) {
          this.staffList = res.data ? res.data : [];
          this.staffList.forEach((a) => {
            a.status = 2;
          });
        } else {
          // console.log(res)
        }
      });
    },
    // 获取房间列表
    getRoomList() {
      getSearchRoomList({ mainId: window.sessionStorage.mainId }).then((res) => {
        if (res.code == 0) {
          this.roomList = res.data ? res.data : [];
        } else {
          // console.log(res)
        }
      });
    },
    // 选择订单状态
    chooseOrderStatus(val) {
      this.orderStatusVal = val;
      if (val == 0) {
        this.activeName = 'service-all';
      } else if (val == 1) {
        this.activeName = 'service-not';
      } else if (val == 2) {
        this.activeName = 'service-end';
      } else if (val == 3) {
        this.activeName = 'service-part';
      } else if (val == 4) {
        this.activeName = 'service-refund';
      }
    },
    // 选择订单类型
    chooseOrderTypeVal(val) {
      this.orderTypeVal = val;
      this.getListCount();
    },
    // 选择结算日期
    chooseSettlementDate(val) {
      if (this.resetScreenStatus == 2) return;
      if (!val) this.settlementDateVal = [];
      this.getListCount();
    },
    // 选择订单来源
    orderSource(val) {
      this.orderSourceVal = val;
      this.getListCount();
    },
    // 选择使用划扣
    buckle(val) {
      this.buckleVal = val;
      this.getListCount();
    },
    // 选择使用权益
    useQy(val) {
      this.useQyVal = val;
      this.getListCount();
    },
    // 选择使用权益
    useDiscount(val) {
      this.useDiscountVal = val;
      this.getListCount();
    },
  }
};
</script>

<style lang="less" scoped>
.overflowTop {
  overflow: visible;
}
.serviceNav {
  width: 100%;
  margin: 15px 0 20px 0;
  ul {
    list-style: none;
    display: flex;
    li {
      height: 60px;
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
      border-radius: 6px;
      width: 20%;
      margin-right: 20px;
      cursor: pointer;
      img {
        width: 34px;
        height: 34px;
        margin: 13px 20px;
        float: left;
      }
      span {
        font-size: 14px;
        color: #333;
        height: 40px;
        line-height: 40px;
        float: left;
        margin: 10px 0;
      }
    }
  }
  .screenList {
    margin-top: 30px;
    padding: 30px 0 0 30px;
    background-color: #f9f9f9;
    height: auto;
    overflow: hidden;
    .show {
      font-size: 14px;
      cursor: pointer;
      height: 40px;
      line-height: 40px;
    }
    .li {
      width: 380px;
      height: 40px;
      line-height: 40px;
      float: left;
      margin: 0 30px 30px 0;
      p {
        width: 80px;
        float: left;
        font-size: 14px;
        color: #2d2f33;
      }
      .width_300 {
        width: 300px;
        float: left;
      }
    }
  }
}

.orderTab {
  position: absolute;
  background-color: #fff;
  width: inherit;
  padding-top: 10px;
  margin-top: -15px;
  z-index: 3;
  .screen {
    color: #999;
    font-size: 20px;
    cursor: pointer;
    float: right;
    margin-top: -44px;
    margin-right: 30px;
    position: relative;
    z-index: 1;
  }
  .export {
    color: #999;
    font-size: 20px;
    cursor: pointer;
    float: right;
    margin-top: -44px;
    position: relative;
    z-index: 1;
  }
  .screenNum {
    float: right;
    position: relative;
    margin-top: -54px;
    margin-right: -6px;
    min-width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    text-align: center;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    font-size: 16px;
    color: #fff;
    z-index: 1;
  }
}
.exportOrderDia {
  clear: both;
  .el-checkbox {
    min-width: 100px;
  }
  h5 {
    height: 40px;
    line-height: 20px;
    padding-bottom: 20px;
    font-size: 14px;
    color: #333;
  }
  .exportChoose {
    border: 1px solid #ccc;
    border-radius: 5px;
    p {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
      font-size: 14px;
      color: #333;
      background-color: #eee;
      border-bottom: 1px solid #ccc;
    }
    .ecCheckbox {
      padding: 20px;
      .eccDiv {
        clear: both;
        h6 {
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
</style>
